// 代理机构版（展示面板）
<template>
  <div class="wel-con" id="app_index" :class="FullScreen ? 'map-FullScreen' : 'map'">
    <!-- 按钮 -->
    <!-- <div class="Full" @click="buttoncli">
      <i class="el-icon-rank" style="width: 100%;height: 100%;"></i>
    </div> -->
    <div class="head-title">
      <div class="top-left">
        <!-- <img class="top-left_img" src="@/assets/img/big_data/logo.png" /> -->
      </div>
      <div class="top-center">
        <div class="big-title">
          <span>{{ title }}</span>
        </div>
        <div class="sub-title">
          <span>{{ sub_title }}</span>
        </div>
      </div>
      <div class="top-right">
        <div class="top-right_title"></div>
        <div class="top-right_box">
          <!-- <img src="@/assets/img/big_data/set.png" class="top-right_box_img" /> -->
          <!-- 设置 -->
          <div class="fullBtn" @click="buttoncli()">
            <span v-if="FullScreen">退出全屏<i style="margin-left: 4px;" class="el-icon-full-screen"></i></span>
            <span v-else>全屏<i style="margin-left: 4px;" class="el-icon-rank"></i></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 中间主体内容 -->
    
    <div class="smconl" v-if="!showLoad">
      <div class="smcon-left">
        <LeftTop :leftTopData="this.consoleAgencyData.LeftTop"/>
        <LeftBottom :leftBottomData="this.consoleAgencyData.LeftBottom"/>
      </div>
      <div class="smcon-content">
        <div class="smcon-content_header">
          <div class="bordline_top"></div>
          审查中专利
          <div class="bordline_bottom" style="text-align: center;">
            <span style="font-size: 14px;color: #FFFFFF;font-family: FZHei-B01S;font-weight: 400;">(统计所有非有效专利的状态)</span>
          </div>
        </div>
        <div class="smcon-content_box">
          <div style="display: flex;color: #FFFFFF;font-weight: bold;">
            <div style="margin-top: 20px;margin-left: -20px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('进入实审',consoleAgencyData.PatentTrial.trial01)">进入实审</div>
                <div class="trial-value" @click="trailJump('进入实审',consoleAgencyData.PatentTrial.trial01)">{{ consoleAgencyData.PatentTrial.trial01 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" ref="point01" @load="onImageLoad01" @click="trailJump('进入实审',consoleAgencyData.PatentTrial.trial01)">
              </div>
            </div>
            <div style="margin-left: 80px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('等待实审请求',consoleAgencyData.PatentTrial.trial02)">等待实审请求</div>
                <div class="trial-value" @click="trailJump('等待实审请求',consoleAgencyData.PatentTrial.trial02)">{{ consoleAgencyData.PatentTrial.trial02 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" ref="point02" @load="onImageLoad02" @click="trailJump('等待实审请求',consoleAgencyData.PatentTrial.trial02)">
              </div>
            </div>
            <div style="margin-top: 30px;margin-left: 80px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('等待实审提案',consoleAgencyData.PatentTrial.trial03)">等待实审提案</div>
                <div class="trial-value" @click="trailJump('等待实审提案',consoleAgencyData.PatentTrial.trial03)">{{ consoleAgencyData.PatentTrial.trial03 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('等待实审提案',consoleAgencyData.PatentTrial.trial03)">
              </div>
            </div>
            <div style="margin-left: 80px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('一通出案待答复',consoleAgencyData.PatentTrial.trial04)">一通出案待答复</div>
                <div class="trial-value" @click="trailJump('一通出案待答复',consoleAgencyData.PatentTrial.trial04)">{{ consoleAgencyData.PatentTrial.trial04 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('一通出案待答复',consoleAgencyData.PatentTrial.trial04)">
              </div>
            </div>
          </div>
          <div style="display: flex;color: #FFFFFF;font-weight: bold;">
            <div style="margin-top: 20px;margin-left: 20px;">
              <div style="width: 210px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('待质检抽案',consoleAgencyData.PatentTrial.trial05)">待质检抽案（抽检案件）</div>
                <div class="trial-value" @click="trailJump('待质检抽案',consoleAgencyData.PatentTrial.trial05)">{{ consoleAgencyData.PatentTrial.trial05 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('待质检抽案',consoleAgencyData.PatentTrial.trial05)">
              </div>
            </div>
            <div style="margin-left: 30px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('中通回案实审',consoleAgencyData.PatentTrial.trial06)">中通回案实审</div>
                <div class="trial-value" @click="trailJump('中通回案实审',consoleAgencyData.PatentTrial.trial06)">{{ consoleAgencyData.PatentTrial.trial06 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('中通回案实审',consoleAgencyData.PatentTrial.trial06)">
              </div>
            </div>
            <div style="margin-top: 30px;margin-left: 30px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('中通出案待答复',consoleAgencyData.PatentTrial.trial07)">中通出案待答复</div>
                <div class="trial-value" @click="trailJump('中通出案待答复',consoleAgencyData.PatentTrial.trial07)">{{ consoleAgencyData.PatentTrial.trial07 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('中通出案待答复',consoleAgencyData.PatentTrial.trial07)">
              </div>
            </div>
            <div style="margin-left: 40px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('一通回案实审',consoleAgencyData.PatentTrial.trial08)">一通回案实审</div>
                <div class="trial-value" @click="trailJump('一通回案实审',consoleAgencyData.PatentTrial.trial08)">{{ consoleAgencyData.PatentTrial.trial08 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('一通回案实审',consoleAgencyData.PatentTrial.trial08)">
              </div>
            </div>
          </div>
          <div style="display: flex;color: #FFFFFF;font-weight: bold;">
            <div style="margin-top: 60px;margin-left: -20px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('驳回等复审请求',consoleAgencyData.PatentTrial.trial09)">驳回等复审请求</div>
                <div class="trial-value" @click="trailJump('驳回等复审请求',consoleAgencyData.PatentTrial.trial09)">{{ consoleAgencyData.PatentTrial.trial09 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('驳回等复审请求',consoleAgencyData.PatentTrial.trial09)">
              </div>
            </div>
            <div style="margin-top: -60px;">
              <div style="width: 180px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('待发授权办登通知书',consoleAgencyData.PatentTrial.trial10)">待发授权办登通知书</div>
                <div class="trial-value" @click="trailJump('待发授权办登通知书',consoleAgencyData.PatentTrial.trial10)">{{ consoleAgencyData.PatentTrial.trial10 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img"  src="@/assets/img/point.png" @click="trailJump('待发授权办登通知书',consoleAgencyData.PatentTrial.trial10)">
              </div>
            </div>
            <div style="margin-left: -40px;margin-top: 20px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('等年登印费',consoleAgencyData.PatentTrial.trial11)">等年登印费</div>
                <div class="trial-value" @click="trailJump('等年登印费',consoleAgencyData.PatentTrial.trial11)">{{ consoleAgencyData.PatentTrial.trial11 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('等年登印费',consoleAgencyData.PatentTrial.trial11)">
              </div>
            </div>
            <div style="margin-top: -10px;margin-left: 20px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('等待颁证公告',consoleAgencyData.PatentTrial.trial12)">等待颁证公告</div>
                <div class="trial-value" @click="trailJump('等待颁证公告',consoleAgencyData.PatentTrial.trial12)">{{ consoleAgencyData.PatentTrial.trial12 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('等待颁证公告',consoleAgencyData.PatentTrial.trial12)">
              </div>
            </div>
            <div style="margin-top: 60px;margin-left: 20px;">
              <div style="width: 142px;height: 62px;border-radius: 10px;text-align: center;margin: 20px;">
                <div class="trial-name" @click="trailJump('公告封卷',consoleAgencyData.PatentTrial.trial13)">公告封卷</div>
                <div class="trial-value" @click="trailJump('公告封卷',consoleAgencyData.PatentTrial.trial13)">{{ consoleAgencyData.PatentTrial.trial13 }}</div>
              </div>
              <div style="text-align: center;margin-top: -10px;">
                <div class="trial-line"></div>
                <img class="trial-img" src="@/assets/img/point.png" @click="trailJump('公告封卷',consoleAgencyData.PatentTrial.trial13)">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smcon-left">
        <CateCount :cateCountData="this.consoleAgencyData.PatentEeRank"/>
        <!-- <RightBottom :rightBottomData="this.consoleAgencyData.RightBottom"/> -->
      </div>
    </div>
   
    <div class="bottom" v-if="!showLoad">
      <div class="bottom24"></div>
      <div class="bottom12">{{ date }} {{ currentDateWeek }}</div>
      <div class="bottom28">
        <div class="bottom28_item">
          <div class="bottom28_item_box bottom28_item_active">
            <img class="bottom28_item_img" src="@/assets/img/big_data/zst.png" />
          </div>
          <div class="bottom28_item_title">展示台</div>
        </div>
        <div class="bottom28_item" @click='jumpMonitor()'>
          <div class="bottom28_item_box">
            <img class="bottom28_item_img" src="@/assets/img/big_data/kzt.png" />
          </div>
          <div class="bottom28_item_title">控制台</div>
        </div>
        <div class="bottom28_item" @click='jumpIntel()' v-if="user.uid == 16">
          <div class="bottom28_item_box">
            <img class="bottom28_item_img" src="@/assets/img/big_data/znpg.png" />
          </div>
          <div class="bottom28_item_title">智能评估</div>
        </div>
        <div class="bottom28_item" @click='jumpLearn()' v-if="user.uid == 16">
          <div class="bottom28_item_box">
            <img class="bottom28_item_img" src="@/assets/img/big_data/xuexi.png" />
          </div>
          <div class="bottom28_item_title">学习中心</div>
        </div>
      </div>
      <div class="bottom12">数据更新：{{ date }}</div>
      <div class="bottom24"></div>
    </div>
    <div class="load" v-if="showLoad">
      <dv-loading>加载中...</dv-loading>
    </div>
    <!-- <div style="position: absolute;">
      <DynamicLine :point1="startPont1" :point2="startPont2"></DynamicLine>
    </div> -->
  </div>
</template>

<script>
import autofit from 'autofit.js'
import editor from '../../components/kindeditor.vue'
// 导入请求方法
import { consoleAgency, getAdminInfo, consoleAgencyV3 } from '../../api/consoleMG'
// 导入全屏显示方法
import { fullscreenToggel, checkLogin } from "@/utils/util";
import LeftTop from './components/LeftTop.vue'
import CateCount from './components/cateCount.vue'
import LeftBottom from './components/LeftBottom.vue'
import RightBottom from './components/RightBottom.vue'
import contentLeft from './components/contentLeft.vue'
import contentRightTop from './components/contentRightTop.vue'
import contentRightBottom from './components/contentRightBottom.vue'
import DynamicLine from './components/DynamicLine.vue';

export default {
  name: 'app',
  components: {
    contentRightBottom,
    contentRightTop,
    contentLeft,
    RightBottom,
    CateCount,
    LeftTop,
    LeftBottom,
    editor,
    DynamicLine
  },
  data() {
    return {
      FullScreen: false,
      showSwipe: false,
      showLoad: false,
      title: '',
      sub_title: '',
      screenWidth: '',
      screenHeight: '',
      date: '',
      currentDateWeek: '',
      consoleAgencyData:{},
      user: {},
      startPont1: {
         x: 0,
         y: 0
      },
      startPont2: {
         x: 0,
         y: 0
      }
    }
  },
  created() {
    // 时间定时器
    // setInterval(this.getTime, 1000);
    // this.getAdmin();
    // 请求数据
    let user = JSON.parse(localStorage.getItem('userdata'))
    if (user.platform_name != 'undefined') {
      this.title = user.platform_name;
      this.sub_title = user.platform_name_en
    } else {
      this.title = '专利管理系统'
      this.sub_title = 'PATENT MANAGEMENT SYSTEM'
    }
    this.user = user
    this.showLoad = true;
    this.$nextTick(function() {
      this.getConsole()
    });
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    autofit.init({
      designHeight: 1080,
      designWidth: 1920,
      renderDom: "#app_index",
      resize: true
    })
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // 月份从0开始，需要加1
    const day = currentDate.getDate();
    this.date = year + '.' + month.toString().padStart(2, '0') + '.' + day.toString().padStart(2, '0')
    this.currentDateWeek = new Intl.DateTimeFormat('zh-CN', { weekday: 'long' }).format(new Date());
  },
  methods: {
    formatter(number) {
      const numbers = number.toString().split('').reverse()
      const segs = []

      while (numbers.length) segs.push(numbers.splice(0, 3).join(''))

      return segs.join(',').split('').reverse().join('')
    },
    buttoncli() {
      // 是否全屏
      this.FullScreen = !this.FullScreen;
      fullscreenToggel();
    },
    // 当前时间
    getTime() {
      let now = new Date();
      let year = now.getYear();
      year = now.getFullYear();
      let month = now.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let days = now.getDate();
      days = days < 10 ? "0" + days : days;
      let hour = now.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      let minutes = now.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      let seconds = now.getSeconds();
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.nowTime =
        year +
        "-" +
        month +
        "-" +
        days +
        "  " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds;
    },
    // 查看最新公开专利详情
    pubPatInfo(data) {
      console.log('打印点击最新公开信息')
      console.log(data)
      console.log(data.row[1])

    },
    // 查看最新公开专利详情
    newPubilcPatentClick(data) {
      console.log('打印点击最新公开信息')
      console.log(data)
      console.log(data.row[1])
      let zlmc = data.row[1]
      localStorage.setItem('zlmc', zlmc)
      // this.$router.push({ path: '/patent/search' })
      let routeUrl = this.$router.resolve({
        path: '/patent/monitor'
      })
      window.open(routeUrl.href, '_blank')
    },
    // 查看最新申请专利申请人申请的专利
    appPatClick(data) {
      let sqr = data.row[1]
      localStorage.setItem('zlmc', sqr)
      // this.$router.push({ path: '/patent/search' })
      let routeUrl = this.$router.resolve({
        path: '/patent/monitor'
      })
      window.open(routeUrl.href, '_blank')
    },
    // 查看近期待缴专利详情
    patentFeeClick(data) {
      let zlmc = data.row[1]
      localStorage.setItem('zlmc', zlmc)
      // this.$router.push({ path: '/patent/search' })
      let routeUrl = this.$router.resolve({
        path: '/patent/monitor'
      })
      window.open(routeUrl.href, '_blank')
    },
    // 查看申请人排行
    applicantConfigClick(data) {
      let sqr = data.row[1]
      localStorage.setItem('sqr', sqr)
      // this.$router.push({ path: '/patent/search' })
      let routeUrl = this.$router.resolve({
        path: '/patent/monitor'
      })
      window.open(routeUrl.href, '_blank')
    },
    // 查看发明人排行
    inventorConfigClick(data) {
      let fmr = data.row[1]
      localStorage.setItem('fmr', fmr)
      // this.$router.push({ path: '/patent/search' })
      let routeUrl = this.$router.resolve({
        path: '/patent/monitor'
      })
      window.open(routeUrl.href, '_blank')
    },
    
    getConsole() {
      consoleAgencyV3()
        .then(res => {
          res = checkLogin(res);
          if (res.code == 200) {
            console.log('res.data',res.data)
              this.consoleAgencyData = res.data
              this.showLoad = false;
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    getAdmin() {
      getAdminInfo()
        .then(res => {
          res = checkLogin(res);
          if (res.code == 200) {
            console.log(res)
            localStorage.setItem('userdata', JSON.stringify(res.data))
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 跳转到控制台
    jumpMonitor(){
      this.$router.push({ path: '/patent/monitor' })
    },
    // 跳转到智能评估
    jumpIntel(){
      this.$router.push({ path: '/patent/intelEval' })
    },
    // 跳转到学习中心
    jumpLearn(){
      this.$router.push({ path: '/patent/learnCenter' })
    },
    // 跳转监控管理列表-案件状态
    trailJump(name,num){
      if(num <= 0){
        this.$message({
          type: 'info',
          message: '数据为空~'
        })
        return false
      }
      localStorage.setItem('consoleTrial', name)
      window.open('#/patent/monitor','_blank')
    },
    // 获取01的位置
    onImageLoad01(event){
      let point = event.target
      this.startPont1.x = point.offsetLeft
      this.startPont1.y = point.offsetTop
    },
    onImageLoad02(event){
      let point = event.target
      this.startPont2.x = point.offsetLeft
      this.startPont2.y = point.offsetTop
    },
  },


}
</script>
<!-- <script type="text/javascript">
  function drawLine(obj1,obj2){
    // 起点坐标
    var pointX01 = obj1.getBoundingClientRect().left + obj1.clientWidth / 2
    var pointY01 = obj1.getBoundingClientRect().top + obj1.clientHeight / 2
    
    // 终点坐标
    var pointX02 = obj2.getBoundingClientRect().left + obj2.clientWidth / 2
    var pointY02 = obj2.getBoundingClientRect().top + obj2.clienttHeight / 2

    // 计算连接线长度
    var length = Math.sqrt((pointX02 - pointX01) * (pointX02 - pointX01) + (pointY02 - pointY01) * (pointY02 - pointY01))
    
    // 计算连接线旋转弧度值
    var rad = Math.atan2((pointY02 - pointY01), (pointX02 - pointX01))

    // 连接线未旋转前，起点坐标计算
    var top = (pointY01 + pointY02) / 2
    var left = (pointX01 + pointX02) / 2 - length / 2

    // 创建连接线dom节点,并设置样式
    var line = document.createElement('div')
    var style = 'position: absolute;background-color: red;height: 1px;top'+ top + 'px;left:' + left + 'px;width:' + length + 'px;transform: rotate(' + rad + 'rad);'
    line.setAttribute('style',style)
    document.body.appendChild(line)
  }
  drawLine(document.getElementById('point01'),document.getElementById('point02'))
  console.log(document.getElementById('point01'))
</script> -->
<style>
.smconl {
  display: flex;
  justify-content: center;
}

.smcon-content {
  width: 1018px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.smcon-content_box {
  /* display: flex; */
  flex: 1;
}

.smcon-content_left {
  width: 550px;
  position: relative;
  padding-left: 50px;
  box-sizing: border-box;
}

.smcon-content_right {
  width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.smcon-content_header {
  width: 759px;
  height: 61px;
  flex-shrink: 0;
  font-family: 'Alimama ShuHeiTi';
  font-weight: bold;
  font-size: 25px;
  color: #FEFEFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 27px;
  margin-bottom: 40px;
  position: relative;
}

.bordline_top {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, rgba(0, 0, 0, 0)0%, #9BC1FF 50%, rgba(0, 0, 0, 0)100%);
  position: absolute;
  top: 0
}

.bordline_bottom {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, rgba(0, 0, 0, 0)0%, #9BC1FF 50%, rgba(0, 0, 0, 0)100%);
  position: absolute;
  bottom: 0
}

.smcon-left {}

.wel-con {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 800px;
  box-sizing: border-box;
  background-image: url("../../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.Full {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 20px;
  right: 15px;
  z-index: 1000;
  box-sizing: border-box;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}

.Full:hover {
  background-color: #fff;
}

.Full>img {
  width: 100%;
  height: 100%;
}

.map {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.map-FullScreen {
  z-index: 9000;
  object-fit: contain;
  position: fixed !important;
  top: 0px !important;
  right: 0px !important;
  bottom: 0px !important;
  left: 0px !important;
  box-sizing: border-box !important;
  min-width: 0px !important;
  max-width: none !important;
  min-height: 0px !important;
  max-height: none !important;
  width: 100% !important;
  height: 100% !important;
  transform: none !important;
  margin: 0px !important;
}

.head-title {
  width: 100%;
  height: 10%;
  text-align: center;
  display: flex;
  justify-content: space-between;
  background-image: url("../../assets/img/bg_top.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.top-center {
  width: 68%;
  display: flex;
  flex-direction: column;
}

.top-left {
  width: 15.6%;
  padding-top: 8px;
  text-align: right;
}

.top-left_img {
  width: 63px;
  height: 63px;
}

.top-right {
  width: 16%;
  display: flex;
  height: 80px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 17px;
  color: #9BC1FF;
}

.top-right_title {
  padding-top: 36px;
}

.top-right_box {
  height: 40px;
  display: flex;
  align-items: center;
  margin-left: 60px;
}

.top-right_box_img {
  margin-right: 6px;
}

.big-title {
  display: inline-block;
  font-size: 30px;
  color: #f9fbff;
  position: relative;
  height: 30px;
  margin-top: 10px;
  letter-spacing: 8px;
  font-weight: 1000;
}

.big-title>span {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
}

.sub-title {
  display: inline-block;
  font-size: 12px;
  color: #5070ad;
  position: relative;
  height: 30px;
  margin-top: 10px;
}

.sub-title>span {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
}

.bottom {
  width: 100%;
  height: 10%;
  text-align: center;
  display: flex;
  justify-content: space-between;
  background-image: url("../../assets/img/bg_bottom.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: 0;
}

.smcon {
  /* position: absolute; */
  top: 0px;
  left: 0px;
  height: 80%;
  width: 100%;
  box-sizing: border-box;
  /* padding-top: 100px; */
}

.border-con {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

.border-smcon {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}

.bottom24 {
  width: 24%;
}

.bottom12 {
  width: 12%;
  height: 61px;
  color: #f9fbff;
  position: relative;
  line-height: 61px;
  top: 50px;
  color: #6684B5
}

.bottom28 {
  /* width: 25.5%; */
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 17px;
  color: #FFFFFF;
  padding-left: 140px;
  padding-right: 140px;
  box-sizing: border-box;
  position: relative;
}

.bottom28_item_box {
  box-shadow: 0px 0px 13px 3px rgba(2, 26, 67, 0.09);
  border-radius: 50%;
  width: 45px;
  height: 45px;
  position: absolute;
  top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottom28_item_active {
  background: #4C8FFA;
}

.bottom28_item_title {
  position: absolute;
  bottom: 16px
}

.bottom28_item {
  flex: 1;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 14px;
  box-sizing: border-box;
  cursor: pointer;
}

.bottom28_item_img {
  width: 25px;
  height: 25px;
}

.load {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -50px;
}
.fullBtn {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 24px;
}
.trial-name {
  background-color: rgba(24, 126, 125, 1);
  height: 26px;
  border-radius: 10px 10px 0px 0px;
  font-size: 14px;
  line-height: 30px;
  cursor: pointer;
}
.trial-value {
  background-color: rgba(33, 60, 105, 0.6);
  height: 36px;
  border-radius: 0px 0px 10px 10px;
  font-size: 25px;
  line-height: 36px;
  cursor: pointer;
}
.trial-line {
  width:2px;
  height: 40px;
  background-color: rgba(24, 126, 125, 0.8);
  margin-left: auto;
  margin-right: auto;
}
.trial-img {
  width: 24px;
  height: 24px;
  margin-top: 10px;
  border-radius: 50%;
  cursor: pointer;
  animation: glow 2s infinite alternate;
}
@keyframes glow {
  0% {
    box-shadow: 0 0 10px rgba(24, 126, 125, 0.5), 0 0 20px rgba(24, 126, 125, 0.5), 0 0 30px rgba(24, 126, 125, 0.5);
  }
  100% {
    box-shadow: 0 0 20px rgba(255, 255, 255, 1), 0 0 40px rgba(255, 255, 255, 1), 0 0 60px rgba(255, 255, 255, 1);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/console/consoleAgency.vue